var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M34.999 16.7437C34.999 28.4103 19.999 38.4103 19.999 38.4103C19.999 38.4103 4.99902 28.4103 4.99902 16.7437C4.99902 12.7654 6.57938 8.9501 9.39242 6.13705C12.2055 3.324 16.0208 1.74365 19.999 1.74365C23.9773 1.74365 27.7926 3.324 30.6056 6.13705C33.4187 8.9501 34.999 12.7654 34.999 16.7437Z","stroke":"#D25D18","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M20 21.7437C22.7614 21.7437 25 19.5051 25 16.7437C25 13.9822 22.7614 11.7437 20 11.7437C17.2386 11.7437 15 13.9822 15 16.7437C15 19.5051 17.2386 21.7437 20 21.7437Z","stroke":"#D25D18","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Pin.defaultProps = {"width":"40","height":"41","viewBox":"0 0 40 41","fill":"none"};

module.exports = Pin;

Pin.default = Pin;
